import { useQuery } from '../models/reactUtils'
import { observer } from 'mobx-react'
import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Virtuoso } from 'react-virtuoso'

import { Grid } from '@mui/material'
import Paper from '@mui/material/Paper'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'

import LocationItem from './LocationItem'
import MobileShowMapButton from './MobileShowMapButton'

const LocationsList = ({ toggleDrawer }) => {
  const { store } = useQuery()
  const { t } = useTranslation()
  const theme = useTheme()
  const desktop = useMediaQuery(theme.breakpoints.up('md'))
  const locations = store.locationStore.locations
  const staticPage = store.staticPage
  const virtuoso = useRef(null)

  // Find and scroll to the index of the focused location
  useEffect(() => {
    if (store.locationStore.focusLocation) {
      const index = locations.findIndex(
        location => location.id === store.locationStore.focusLocation.id
      )
      if (index !== -1 && virtuoso.current !== null) {
        virtuoso.current.scrollToIndex({
          index,
          align: 'start',
          behavior: 'smooth',
        })
      }
    }
  }, [store.locationStore.focusLocation, locations])

  const locationListHeader = () => {
    return (
      <Grid
        container
        direction="column"
        spacing={1}
        sx={{ py: 2, textAlign: 'center' }}
      >
        <Grid item>
          <MobileShowMapButton
            isDesktop={desktop}
            toggleDrawer={toggleDrawer}
          />
        </Grid>
        <Grid item>
          <Typography variant="caption" align="center">
            {t(`Found {{number}} locations based on your search`, {
              number: locations.length,
            })}
          </Typography>
        </Grid>
      </Grid>
    )
  }

  if (store.locationStore.hasLocations) {
    return (
      <>
        {!staticPage ? (
          <Paper
            aria-label="Search Background"
            elevation={1}
            square
            sx={{
              pt: { xs: 15.5, md: 9 },
              pb: { xs: 2, md: 2 },
            }}
          />
        ) : null}
        <Virtuoso
          ref={virtuoso}
          aria-label="Locations List"
          style={{ height: '100vh' }}
          data={locations}
          components={{ Header: locationListHeader }}
          itemContent={(_index, location) => (
            <LocationItem
              key={location.id}
              location={location}
              toggleDrawer={toggleDrawer}
            />
          )}
        />
      </>
    )
  }
  return null
}

LocationsList.displayName = 'LocationsList'

export default observer(LocationsList)
